import React from "react";

const IMG = "https://images.unsplash.com/photo-1779700210487-a01758a3c55a?auto=format&fit=crop&w=1600&q=80";

export default function AuthHero({ headline, points = [] }) {
  return (
    <div className="hidden lg:block relative overflow-hidden grain m-3 rounded-2xl" data-testid="auth-hero">
      <img src={IMG} alt="" className="absolute inset-0 w-full h-full object-cover scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#07080f] via-[#07080f]/70 to-[#07080f]/20" />
      <div className="absolute inset-0 bg-[hsl(var(--primary))]/10 mix-blend-color" />
      <div className="relative h-full flex flex-col justify-end p-12 text-white">
        <div className="eyebrow text-white/60 mb-4">Auto-Close-Ai</div>
        <h2 className="display text-4xl xl:text-5xl font-extrabold tracking-tight leading-[1.02] max-w-xl">{headline}</h2>
        <ul className="mt-8 grid gap-3 max-w-lg stagger">
          {points.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-start gap-3 text-sm text-white/80">
              <span className="mt-0.5 w-6 h-6 rounded-md bg-white/10 border border-white/15 backdrop-blur flex items-center justify-center shrink-0"><Icon className="w-3.5 h-3.5" /></span>
              {text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
